(() => {
  const parseGalleryImages = (button) => {
    try {
      return JSON.parse(button.dataset.galleryImages || '[]');
    } catch (error) {
      console.warn('Unable to parse product-card gallery images.', error);
      return [];
    }
  };

  const updatePrice = (priceBox, button) => {
    if (!priceBox) return;

    const price = button.dataset.price || '';
    const compare = button.dataset.compare || '';
    const isSale = Boolean(compare && compare !== price);
    const priceElement = document.createElement('span');
    priceElement.className = 'product-price';
    priceElement.textContent = price;

    priceBox.replaceChildren(priceElement);
    priceBox.classList.toggle('on-sale', isSale);

    if (isSale) {
      const compareElement = document.createElement('span');
      compareElement.className = 'product-card-variant__compare-at';
      compareElement.textContent = compare;
      priceBox.append(compareElement);
    }
  };

  const updateSaleBadge = (card, button) => {
    const saleBadge = card.querySelector('[data-sale-badge]');
    if (saleBadge) saleBadge.hidden = button.dataset.onSale !== 'true';
  };

  const updateFallbackImages = (card, button) => {
    const primaryImage = card.querySelector('.primary-img');
    const secondaryImage = card.querySelector('.secondary-img');

    if (button.dataset.image && primaryImage) {
      primaryImage.removeAttribute('srcset');
      primaryImage.src = button.dataset.image;
    }

    if (button.dataset.hoverImage && secondaryImage) {
      secondaryImage.src = button.dataset.hoverImage;
      secondaryImage.style.display = 'block';
    } else if (secondaryImage) {
      secondaryImage.style.display = 'none';
    }
  };

  const updateActiveSwatch = (card, button) => {
    card.querySelectorAll('button.swatch-color').forEach((swatch) => swatch.classList.remove('active'));
    button.classList.add('active');
  };

  const initializeFeaturedCard = (card) => {
    if (card.dataset.variantSwatchesInitialized === 'true') return;
    card.dataset.variantSwatchesInitialized = 'true';

    const gallery = card.querySelector('product-card-gallery');
    const subtitle = card.querySelector('.product-card-variant__subtitle');
    const priceBox = card.querySelector('.product-card-variant__price');
    const titleLink = card.querySelector('.product-card-variant__title a');
    const baseUrl = card.dataset.baseUrl;

    card.addEventListener('click', (event) => {
      const button = event.target.closest('button.swatch-color');
      if (!button || !card.contains(button)) return;

      event.preventDefault();
      event.stopPropagation();

      const variantUrl = `${baseUrl}?variant=${button.dataset.variantId}`;
      const galleryImages = parseGalleryImages(button);

      if (gallery && galleryImages.length > 0 && typeof gallery.setVariantImages === 'function') {
        gallery.setVariantImages(galleryImages, variantUrl);
      } else {
        updateFallbackImages(card, button);
      }

      if (subtitle) subtitle.textContent = button.dataset.title || '';
      updatePrice(priceBox, button);
      updateSaleBadge(card, button);

      card.querySelectorAll('.product-card-gallery__slide, .product-card__image-link').forEach((link) => {
        link.href = variantUrl;
      });

      if (titleLink) titleLink.href = variantUrl;
      updateActiveSwatch(card, button);
    });

    const activeSwatch = card.querySelector('.swatch-color.active[data-gallery-images]');
    if (gallery && activeSwatch && typeof gallery.setVariantImages === 'function') {
      gallery.setVariantImages(parseGalleryImages(activeSwatch), `${baseUrl}?variant=${activeSwatch.dataset.variantId}`);
    }
  };

  const initializeCollectionVariantCard = (card) => {
    if (card.dataset.productCardVariantInitialized === 'true') return;
    card.dataset.productCardVariantInitialized = 'true';

    const gallery = card.querySelector('product-card-gallery');
    const subtitle = card.querySelector('.product-card-variant__subtitle');
    const priceBox = card.querySelector('.product-card-variant__price');

    card.addEventListener('click', (event) => {
      const button = event.target.closest('button.swatch-color');

      if (button && card.contains(button)) {
        event.stopPropagation();

        const variantId = button.dataset.variantId;
        const variantUrl = `${card.dataset.productUrl.split('?')[0]}?variant=${variantId}`;
        const galleryImages = parseGalleryImages(button);

        if (gallery && galleryImages.length > 0 && typeof gallery.setVariantImages === 'function') {
          gallery.setVariantImages(galleryImages, variantUrl);
        } else {
          updateFallbackImages(card, button);
        }

        if (subtitle) subtitle.textContent = button.dataset.title || '';
        updatePrice(priceBox, button);
        updateSaleBadge(card, button);
        updateActiveSwatch(card, button);

        if (variantId) card.dataset.productUrl = variantUrl;
        return;
      }

      if (event.defaultPrevented || event.target.closest('a, button')) return;

      if (card.dataset.openNewTab === 'true') {
        window.open(card.dataset.productUrl, '_blank', 'noopener');
      } else {
        window.location.href = card.dataset.productUrl;
      }
    });

    const activeSwatch = card.querySelector('.swatch-color.active[data-gallery-images]');
    if (gallery && activeSwatch && typeof gallery.setVariantImages === 'function') {
      gallery.setVariantImages(parseGalleryImages(activeSwatch), card.dataset.productUrl);
    }
  };

  const initializeCards = (root = document) => {
    root.querySelectorAll('.product-card--fc').forEach(initializeFeaturedCard);
    root.querySelectorAll('.product-card-variant').forEach(initializeCollectionVariantCard);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeCards(), { once: true });
  } else {
    initializeCards();
  }

  document.addEventListener('shopify:section:load', (event) => initializeCards(event.target));
})();
